module.exports = __webpack_public_path__ + "54cf98f5/img/share-action-icon.9c12578c.svg";